<template>
  <div class="desc" @click.stop="bindStop">
    <div class="title">食物红绿灯说明</div>
    <div class="close iconfont icon-cha" @click="bindClose"></div>
    <div class="list">
      <div class="item" v-for="(item, index) in descData" :key="index">
        <div class="item-top">
          <span class="dot" :style="{ backgroundColor: item.color }"></span>
          <span class="item-title">{{ item.name }}</span>
        </div>
        <div class="text">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      descData: [
        {
          color: '#63C6AB',
          name: '绿灯食物',
          text: '食物营养质量优秀，可以每天足量吃'
        },
        {
          color: '#FFB300',
          name: '黄灯食物',
          text: '食物营养质量良好，可以每天适量吃'
        },
        {
          color: '#FF2B48',
          name: '红灯食物',
          text: '食物对人体健康有不利的因素（如高油、高盐、高糖食物），过多摄入会增加发生疾病的风险，应尽量避免吃'
        }
      ]
    }
  },
  mounted() {},
  methods: {
    bindStop() {},
    bindClose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.desc {
  width: 100%;
  background: #f9f9f9;
  padding: 17px 20px;
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  box-sizing: border-box;
  animation: moveup 0.3s ease;
  overflow: hidden;
  .title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    margin-bottom: 20px;
  }
  .close {
    position: absolute;
    padding: 10px;
    top: 5px;
    right: 5px;
    color: #000;
    font-size: 14px;
  }
  .list {
    margin-bottom: 40px;
    .item {
      margin-bottom: 20px;
      .item-top {
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        .dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 8px;
        }
        .item-title {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 20px;
        }
      }
      .text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
      }
    }
    .item:last-child {
      margin-bottom: 0;
    }
  }
}
@keyframes moveup {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0%);
  }
}
</style>
